// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07d3368f","501":"f8ef3a60","538":"8cadd9bd","606":"befc4552","925":"6db40635"}[chunkId] + ".chunk.js";
};